import Meta from '@/components/common/Meta'

import StorageAndShippingBoxesPage from '@/v2/components/pages/landing-pages/storage-and-shipping-boxes-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/storage-and-shipping-boxes-page'

interface StorageAndShippingBoxesPageProps {}

const Page: React.FC<StorageAndShippingBoxesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_boxes.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_boxes?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_and_shipping_boxes?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StorageAndShippingBoxesPage />
    </>
  )
}

export default Page
